import React, { useRef, useState } from 'react'
import LeftControl from '../../Components/LeftControl'
import { Button, Divider, Form, Input, Modal, Select, Table, message } from 'antd'
import { Grid } from '@material-ui/core'
import PageHeader from '../../Components/PageHeader'
import HardwareTable from '../../Components/TableComponents/HardwareTable'
import DynamicTable from '../../Components/TableComponents/DynamicTable'
import { dashTableColOther } from '../../Components/TableComponents/constants'
import { EditOutlined, EyeOutlined } from '@ant-design/icons'
import { Link, useHistory } from "react-router-dom";
import TableFilters from '../../Components/Locomotive/TableFilters'
import services from '../../Services'
import { useEffect } from 'react'
import roleManager from "./../../Components/roles";

import moment from 'moment'
import { seriliazeParams } from '../../helpers/seriliazeParams'
import { showText } from '../../helpers/textValidation'
import { exportLocomotiveTicket, getAllLocomotive, getAllLocomotiveTicketSources, getLocomotiveCloseoutReason, updateLocomotiveTicket } from '../../Services/LocomotiveServices'
import { get_site_listing } from '../../Services/employee'
import Services from '../../Services';
import PgDynamicTable from '../../Components/TableComponents/PgDynamicTable'
import PageLayout from '../../Components/LayoutComponents/PageLayout'

const { hr } = services


const LocomotiveTickets = () => {
    const [form] = Form.useForm();

    const {
        employee,
        Storage
    } = Services;

    const [edit, setEdit] = useState(false)
    const [Data, setData] = useState()
    const DataId = Data?.id
    const [closeComments, setCloseComments] = useState([])
    const [SwitchRadio, setSwitchRadio] = useState(true)
    const [sourceData, setSourceData] = useState([])
    const [equipId, setEquipId] = useState([])
    const [closeOutReasonSelect, setCloseOutReasonSelect] = useState({})
    const [Count, setCount] = useState()
    const [location, setLocation] = useState([])
    const [pagination, setPagination] = useState({
        offSet: 0,
        limit: 10,
    })
    const [flag, setflag] = useState(false)
    const history = useHistory()
    const [EmployeeListData, setEmployeeListData] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modal_id, setModal_id] = useState(null);

    const { Option } = Select;

    var fetchPersistedFilter = (id) => {

        let existingFilters = JSON.parse(localStorage.getItem('LocoTickets_Filters'))
        return existingFilters ? existingFilters[id] : null

    }

    const [equipId2, setEquipId2] = useState()
    const [LocationId, setLocationId] = useState()
    const [sourceID, setSourceID] = useState()
    const [RequestedForId, setRequestedForId] = useState()
    const [selectedAssignTo, setSelectedAssignTo] = useState([])
    const [selectedOpen, setSelectedOpen] = useState(null)



    useEffect(() => {

        let existingFilters = JSON.parse(localStorage.getItem('LocoTickets_Filters'))


        let map = {
            equipID: setEquipId2,
            locationID: setLocationId,
            requestedForID: setRequestedForId,
            source: setSourceID,
            status: setSelectedOpen,
            assignedToID: setSelectedAssignTo,
            // Include this line for AssignedTo
        }
        if (existingFilters)
            Object.keys(existingFilters)?.forEach((key) => {

                // if (existingFilters[key])
                //     map[key] && map[key](existingFilters[key])
                // if (key == 'assignedToID') {
                //      
                //     // Ensure proper handling of "Assigned to" option
                //     map[key] && map[key](JSON.parse(existingFilters[key]));
                // } else {
                map[key] && map[key](existingFilters[key]);
                // }
            }
            )

    }, [])


    const states = {
        equipId: equipId2, setEquipId: setEquipId2,
        LocationId, setLocationId,
        sourceID, setSourceID,
        RequestedForId, setRequestedForId,
        selectedAssignTo, setSelectedAssignTo,
        selectedOpen, setSelectedOpen
    }


    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
    const fetchData = async (LocationId, equipId, SwitchStatus = true, employeeID, sourceID) => {
        let params = '?'.concat(seriliazeParams({ offset: pagination?.offSet, limit: pagination?.limit, LocationId: LocationId, EquipMasterId: equipId, isCompleted: SwitchStatus, FEmployeeId: employeeID, TicketSourceId: sourceID }))
        let response = await hr.listTicketByCategory({ roleId: 4, params, });
        const { data } = response;
        setData((prev) => prev = data?.rows);
        setCount(data?.count)
    }

    const exportLocomotiveSheet = async (LocationId, equipId, SwitchStatus = 1, employeeID, sourceID) => {
        let params = '?'.concat(seriliazeParams({ LocationId: LocationId, EquipMasterId: equipId, isCompleted: SwitchStatus, FEmployeeId: employeeID, TicketSourceId: sourceID }))
        const result = await exportLocomotiveTicket(({ roleId: 4, params, }))
        const blob = new Blob([result], { type: 'text/csv' });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'LocomotiveTicket.csv';
        link.click();
        window.URL.revokeObjectURL(blobUrl);
    }

    const getFilterDataQuipId = async () => {
        const result = await getAllLocomotive()
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => {
                return {
                    label: item?.EquipUID,
                    value: item?.id
                }
            })
            setEquipId(data)

        }
    }
    const getCloseOutComments = async () => {
        const result = await getLocomotiveCloseoutReason(4)
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => {
                return {
                    label: item?.CloseType,
                    value: item?.id
                }
            })
            setCloseComments(data)
        }
    }
    const getSiteLocation = async () => {
        const result = await get_site_listing()
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => {
                return {
                    label: item?.title,
                    value: item?.id
                }
            })
            setLocation(data)

        }
    }

    const onNavigate = (id) => {

        localStorage.setItem('LocoTickets_Filters',
            JSON.stringify({
                equipID: equipId2,
                locationID: LocationId,
                source: sourceID,
                requestedForID: RequestedForId,
                assignedToID: selectedAssignTo,
                status: selectedOpen

            }))
        history.push(`/LocomotiveTicketEdit`, { id })

    }

    let table = {
        header: [
            "Tck ID",
            "Equip ID",
            "Location",
            "Entered By",
            "Date Entered",
            "Source",
            // "Type",
            "Category",
            "View",
            // "Completed",
            roleManager("locomotive", "TicketEdit", "TableEdit") && "Actions"

        ],
        rows: Data?.map((col, index) => [
            showText(col?.id),
            showText(col?.EquipId?.EquipUID),
            <p style={{ width: "fit-content", }}>
                {showText(col?.TGSLocation?.name)}
            </p>,
            showText(col?.FEmployee ? col?.FEmployee?.firstName + " " + col?.FEmployee?.lastName : col?.employeeName),
            col?.OpenDate ? moment(col?.OpenDate)?.utc()?.format("MM-DD-YYYY") : "N/A",
            showText(col?.TicketSource?.name),
            <p style={{ width: "100px", overflow: 'hidden', whiteSpace: "wrap" }}>{col?.TicketCategory?.name ? col?.TicketCategory?.name : showText(col?.TicketCategoryText)}</p>,
            <Button className={col?.isCompleted ? "ViewIconNew" : "ViewIcon"} onClick={() => onNavigate(col?.id)}><p></p></Button>
            ,
            roleManager("locomotive", "TicketEdit", "TableEdit") && (!col?.isCompleted
                ? <Select
                    key={col?.id}
                    style={{ width: "200px" }}
                    placeholder='Close out reason.'
                    showSearch
                    defaultValue={col?.TicketClose?.CloseType}
                    value={closeOutReasonSelect[col?.id] ?? null}
                    optionFilterProp="children"
                    onChange={(value) => { CloseOutCommentChange(col, value) }}
                    onSearch={() => { }}
                    filterOption={filterOption}
                    options={closeComments}
                /> : <p key={index}>{showText(col?.TicketClose?.CloseType)}</p>)])
    }

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
        setCloseOutReasonSelect({})
    };



    const getEmployeeData = async () => {
        let result = await employee.get_employee_listing_not_Terminated()
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => {
                return {
                    label: `${item?.firstName} ${item?.lastName}`,
                    value: item?.id
                }
            })
            setEmployeeListData(data)
        }
    }

    const CloseOutCommentChange = async (record, commentId) => {

        setCloseOutReasonSelect(prev => {
            return {
                ...prev,
                [record?.id]: commentId
            }
        })
        if (commentId === 3 && record?.EquipId?.EquipStatus !== 5) {
            setModal_id(record?.id)
            setIsModalOpen(true);
        } else {
            const data = {
                TicketCloseId: commentId,
                close: true
            };
            const result = await updateLocomotiveTicket(record?.id, data);
            if (result?.httpStatus === 200) {
                message.success('Successfully Updated!');
                setflag(!flag);
            }
        }
    }


    const onFinishModal = async (values, form) => {

        setIsModalOpen(false);
        form.resetFields();

        const { dropdown } = values;

        const data = {
            TicketCloseId: 3,
            close: true,
            repair: dropdown,
        };
        const result = await updateLocomotiveTicket(modal_id, data);
        if (result?.httpStatus === 200) {
            message.success('Successfully Updated!');
            setflag(!flag);
            form.resetFields();
            setCloseOutReasonSelect({})
        }
        else {
            form.resetFields();
            setCloseOutReasonSelect({})
        }
    };

    const getAllTicketSource = async () => {
        const result = await getAllLocomotiveTicketSources()
        if (result?.httpStatus === 200) {
            setSourceData(result?.data)
        }
    }
    useEffect(() => {
        getFilterDataQuipId()
        getSiteLocation()
        getCloseOutComments()
        getAllTicketSource()
        getEmployeeData()
    }, [])
    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Locomotive Tickets</Grid>
                <div>
                    <TableFilters states={states} mode="ticket" exportData={exportLocomotiveSheet} pagination={pagination} edit={edit} flag={flag} setEdit={setEdit} setSwitchRadio={setSwitchRadio} callApi={fetchData} options={{ searchBar: false, moreFilter: true, locationData: { data: location }, equipIdData: { data: equipId }, sourceData: { data: sourceData }, employeeData: { data: EmployeeListData }, selectedAssignTo: { data: selectedAssignTo } }} />
                </div>
                <div style={{}}>
                    <PgDynamicTable tableData={table} setPagination={setPagination} pagination={pagination} edit={edit} count={Count} />
                </div>

            </Grid>
            <Grid>
                <Modal title="Close- Open WO" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={false}>
                    <Form
                        form={form}

                        labelCol={{
                            span: 6,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        layout="horizontal"
                        onFinish={(values) => onFinishModal(values, form)}
                    >
                        <p style={{ fontWeight: 'bold' }}>Is Locomotive Serviceable?</p>
                        <Form.Item
                            name="dropdown"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select an option!',
                                },
                            ]}
                        >
                            <Select placeholder="Select an option">
                                <Option value="1">Yes</Option>
                                <Option value="0">No</Option>
                            </Select>
                        </Form.Item>



                        <Form.Item wrapperCol={{ offset: 8 }}>
                            <Button style={{ background: '#2963AD', color: 'white', width: '50%', marginTop: '10px' }} htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </Grid>
        </PageLayout>
    )
}

export default LocomotiveTickets